module.exports = new __parcel__URL__("puissancebrick.3aa77eec.avif").toString();